import {GetServerSideProps} from "next";
import {LastMinuteDeal} from "@/components/LastMinute";
import CardOffer from "@/components/CardOffer";
import Head from "next/head";


export default function OffertaLastMinute({offers}: any) {


    return (
        <>

            <Head>
                <title>Offerte Last Minute Auto - Gruppo Piccirillo | Occasioni da Non Perdere</title>
                <meta name="description"
                      content="Non lasciarti sfuggire le offerte last minute di Gruppo Piccirillo! Auto nuove e usate a prezzi scontati, con promozioni imperdibili su noleggio e vendita."/>
                <meta name="keywords" content="offerte, last minute, viaggi, vacanze, risparmio"/>
                <link rel="canonical" href={`${process.env.NEXT_PUBLIC_BASE_URL}/offerte-last-minute`}/>

                {/* Open Graph */}
                <meta property="og:title"
                      content="Offerte Last Minute Auto - Gruppo Piccirillo | Occasioni da Non Perdere"/>
                <meta property="og:description"
                      content="Non lasciarti sfuggire le offerte last minute di Gruppo Piccirillo! Auto nuove e usate a prezzi scontati, con promozioni imperdibili su noleggio e vendita."/>
                <meta property="og:url" content={`${process.env.NEXT_PUBLIC_BASE_URL}/offerte-last-minute`}/>
                <meta property="og:image" content={offers[0]?.imageUrl || "/default-image.jpg"}/>
                <meta property="og:type" content="website"/>

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title"
                      content="Offerte Last Minute Auto - Gruppo Piccirillo | Occasioni da Non Perdere"/>
                <meta name="twitter:description"
                      content="Non lasciarti sfuggire le offerte last minute di Gruppo Piccirillo! Auto nuove e usate a prezzi scontati, con promozioni imperdibili su noleggio e vendita."/>
                <meta name="twitter:image" content={offers[0]?.imageUrl || "/default-image.jpg"}/>

                {/* Schema JSON-LD */}
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ItemList",
                            name: "Offerte Last Minute Auto - Gruppo Piccirillo | Occasioni da Non Perdere",
                            description:
                                "Non lasciarti sfuggire le offerte last minute di Gruppo Piccirillo! Auto nuove e usate a prezzi scontati, con promozioni imperdibili su noleggio e vendita.",
                            itemListElement: offers.map((offer: any, index: any) => ({
                                "@type": "ListItem",
                                position: index + 1,
                                item: {
                                    "@type": "Offer",
                                    name: offer.title,
                                    description: offer.subtitle,
                                    image: offer.imageUrl,
                                    url: `${process.env.NEXT_PUBLIC_BASE_URL}/offerta-last-minute/${offer.slug.current}`,
                                    price: offer.price,
                                    priceCurrency: "EUR",
                                    availability: "https://schema.org/InStock",
                                },
                            })),
                        }),
                    }}
                />
            </Head>

            <div className="px-4 py-6">
                <h1 className="text-3xl sm:text-4xl font-bold text-center text-gray-900">Offerte Last Minute</h1>
                <h2 className="text-sm sm:text-base font-normal text-center mx-auto text-gray-500 max-w-prose">
                    Scopri le offerte last minute di Gruppo Piccirillo e approfitta di prezzi esclusivi su auto nuove,
                    usate e a km
                    zero. Occasioni imperdibili e veicoli disponibili subito, con promozioni limitate nel tempo.
                </h2>
            </div>

            <div className="max-w-7xl max-md:px-4 mx-auto grid grid-cols-4 max-sm:grid-cols-2 gap-4 py-10">


                {
                    offers.map((offer: LastMinuteDeal) => (
                        <CardOffer
                            id={offer._id}
                            title={offer.title}
                            description={offer.subtitle}
                            price={offer.price}
                            image={offer.imageUrl}
                            rate={offer.installment}
                            slug={offer.slug}
                        />
                    ))}
            </div>
        </>
    )

}


export const getServerSideProps: GetServerSideProps = async (context) => {
    const {req, params} = context;
    const protocol = req.headers['x-forwarded-proto'] || 'http';
    const host = req.headers['x-forwarded-host'] || req.headers.host;
    const baseURL = `${protocol}://${host}`;

    try {
        const slug = params?.slug;
        let fetchUrl = `${baseURL}/api/offers`;
        if (slug) fetchUrl += `?slug=${slug}`;

        // Eseguire le richieste in parallelo
        const [responseOffers] = await Promise.all([
            fetch(fetchUrl),
        ]);

        const {offers}: { offers: LastMinuteDeal[] } = await responseOffers.json();

        return {
            props: {
                offers,
            }
        };
    } catch (error) {
        console.error("Error fetching data:", error);

        return {
            props: {
                offers: [],
            }
        };
    }
};
